import React, { Component } from 'react';
import EventController from '../controllers/EventController'
import CreateEvent from './event/CreateEvent'
import PacmanLoader from "react-spinners/PacmanLoader";
import FindMember from './find-member/FindMember';
import CurrentEventViewModel from '../models/events/currentEventViewModel';
import AttendeeList from './attendee-list/AttendeeList'
import { MemberViewModel } from '../models/member/MemberViewModel'
import FingerprintReader from './FingerprintReader'

interface IProps {
  fingerprintReader: FingerprintReader
}

interface IState {
  Loading: boolean;
  Event: CurrentEventViewModel | null;
  AttendeeRefresh: boolean;
  CurrentMember: MemberViewModel | null;
}
export class Home extends Component<IProps, IState> {
  static displayName = Home.name;
  eventController;
  constructor(props: IProps) {
    super(props)
    this.state = { Loading: true, Event: null, AttendeeRefresh: true, CurrentMember: null }
    this.eventController = new EventController();
    this.getCurrentEvent = this.getCurrentEvent.bind(this);
    this.updateAttendeeState = this.updateAttendeeState.bind(this);
    this.updateCurrentMember = this.updateCurrentMember.bind(this);
    this.endEvent = this.endEvent.bind(this);
  }

  async componentDidMount() {
    await this.getCurrentEvent();
  }

  updateAttendeeState(state: boolean) {
    this.setState({ AttendeeRefresh: state });
  }

  updateCurrentMember(member: MemberViewModel | null) {
    this.setState({ CurrentMember: member });
  }

  async getCurrentEvent() {
    this.setState({ Loading: true });
    var result = await this.eventController.GetCurrentEvent();
    this.setState({ Event: result });
    this.setState({ Loading: false });
  }

  async endEvent() {
    var result = window.confirm("This will sign out all members. Are you sure?");
    if (result) {
      this.setState({ Loading: true });
      var result = await this.eventController.EndEvent();
      if (result) {
        this.setState({ Event: null });
      }
      this.setState({ Loading: false });
    }
  }

  reload = async () => {
    await this.getCurrentEvent();
  }

  render() {
    const loading = this.state.Loading;
    const event = this.state.Event
    if (loading) {
      return (
        <PacmanLoader />
      )
    }
    else if (event) {
      return (
        <div>
          <div className="text-center">
            <h1>{event.Name}</h1>
            <h2>{event.Hosts}</h2>
          </div>          
          <div className="float-end">
            <button className="btn btn-light" onClick={this.endEvent}>End Event</button>
          </div>
          <hr />
          <div className="row">
            <div className="col-6">
              <FindMember currentEvent={event} updateAttendeeState={this.updateAttendeeState} setCurrentMember={this.updateCurrentMember} currentMember={this.state.CurrentMember} />
            </div>
            <div className="col-6">
              <AttendeeList updateAttendees={this.state.AttendeeRefresh} updateAttendeeState={this.updateAttendeeState} setCurrentMember={this.updateCurrentMember} />
            </div>
          </div>
        </div>)
    }
    return (
      <CreateEvent reload={this.reload} />
    );
  }
}
